<template>
  <g-popup title="계약 내용" width="600" :background-click="false">
    <template #body>
      <div class="-font-size-12">
        <g-search-bar
          style="width: calc(100% - 30px);"
          no-border
          full
          placeholder="Search anything"
          v-model="searchText" />
        <ag-grid-vue
          style="height: 400px;"
          class="ag-theme-balham"
          row-height="30"
          header-height="30"
          :dom-layout="domLayout"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :rowData="customerContractList"
          :modules="modules"
          rowSelection="multiple"
          :frameworkComponents="frameworkComponents"
          @selection-changed="onSelectionChanged()"
          :suppressScrollOnNewData="true"
          :suppressRowClickSelection="true"
          :suppressCellSelection="true"
          :rowMultiSelectWithClick="true"
          @row-data-changed="onRowDataChanged"
          @row-clicked="cellClicked"
          @grid-ready="onGridReady">
        </ag-grid-vue>
      </div>
    </template>
    <template #footer>
      <g-button @click="onClickCancel" variant="secondary"><span>{{$t('common.cancel')}}</span></g-button><!--
      --><g-button @click="onSubmit" :disabled="!isSelected"><span>{{$t('common.save')}}</span></g-button>
    </template>
  </g-popup>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from '@/pages/mixin/AgGrid.mixin'
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants";
export default {
  name: 'company-contractpopup',
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  props: {
    instKey: {
      type: String,
      default: null
    },
    onSend: {
      type: Function,
      defalut: () => () => {}
    },
    onCancel: {
      type: Function,
      defalut: () => () => {}
    },
    selectedManagerId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchText: '',
      selectedValue: {},
      columnDefs: {},
      defaultColDef: {},
      gridOptions: null,
      customerCode : '',
      customerDeptCode : '',
      checkedRow : '',
      email:'',
      companyCode:'',
      size: 5,
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      paging: {
        pageNo: 1,
        size : DEFAULT_PAGE_SIZE,
        totalCount : 0
      },
    }
  },
  computed: {
    ...mapGetters('customer', ['customerContractList']),
    isSelected () {

      return Object.keys(this.selectedValue).length !== 0
    },

  },
  methods: {
    ...mapActions('customer', ['getCustomerContractList','insertCustomerContractList']),

    onGridReady(params) {
      this.setGridParams(params)
      this.initCustomerConstract()
      this.fitGrid()
    },
    onChangePageNo(pageNo) {
      this.$showSpinner(true)
      this.paging.pageNo = pageNo
      this.initCustomerConstract()
      this.fitGrid();
    },
    onChangePageSize(pageSize) {
      this.paging.size = pageSize
      this.fitGrid();
      this.initCustomerConstract()
    },

    onSelectionChanged : function (event) {

      let selectedRows = this.gridApi.getSelectedRows();
      let selectedRowsString = '';
      selectedRows.forEach(function (selectedRow, index) {

        if (index > 0) {
          selectedRowsString += ', ';
        }
        selectedRowsString += selectedRow.contractCode;
      });
      this.checkedRow = selectedRowsString;
      this.selectedValue   = selectedRowsString;

    },
    cellClicked (e) {

    },
    onSubmit () {

      let value = this.selectedManagerId.split(",",-1)

      let param = {}
      param.popupStr = this.checkedRow
      param.customerCode =  value[0]
      param.customerDeptCode = value[1]
      param.companyCode = value[3]
      param.userEmail = value[2]
      this.selectedValue =  param.popupStr

      this.insertCustomerContractList(param)
      if (this.onSend) {
        this.onSend(this.selectedValue)
        this.$showToast(this.$t('pages_user_CustomerInfo.contract.add'))
      }
      this.$popupManager.close(this.instKey)

    },
    onClickCancel () {
      if (this.onCancel instanceof Function) {
        this.onCancel()
      }
      this.$popupManager.close(this.instKey)
    },
    onRowDataChanged () {

      this.fitGrid()
    },
    setColumn () {
      this.columnDefs = [

        {
          headerName: '',
          field: "contractCode",
          minWidth: 30,
          width: 30,
          cellStyle : {"cursor":"pointer"},
          cellClass: 'cell-wrap-text',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          cellRenderer: params => {
            return `<input type='checkbox' ${params.value ? 'checked' : ''} />`;
          }

        },
        {
          headerName:  this.$t('pages_contract_ContractInfo.column.headerName.id') ,
          field: "contractCode",
          width: 100,
          tooltipField: 'contractCode',

          unSortIcon: true,
          cellStyle : {"cursor":"pointer"}
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.contractName'),
          field: "contractName",
          tooltipField: 'contractName',
          width: 300,
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"}
        },
        {
          headerName: 'customerCode',
          field: "customerCode",
          hide: true,
          comparator: () => false
        },

        {
          headerName: 'deptCode',
          field: "customerDeptCode",
          hide: true,
          comparator: () => false
        },
      ];

      this.fitGrid()
    },
    initCustomerConstract() {
      let value = this.selectedManagerId.split(",",-1)


      let paramValue = {}
      paramValue.customerCode =  value[0]
      paramValue.customerDeptCode =  value[1]
      paramValue.companyCode =  value[3]
      paramValue.userEmail =  value[2]

      this.getCustomerContractList(paramValue)
    }
  },

  watch: {
    searchText () {
      this.gridOptions.api.setQuickFilter(this.searchText)
    },
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/components/CustomerConstractPopup.vue